import { Module, Mutation, VuexModule } from 'vuex-module-decorators';

export enum Routes {
  Configurator = "configurator",
  Recap = "recap"
}

@Module({
	stateFactory: true,
	namespaced: false,
	name: 'routing'
})
export default class Routing extends VuexModule {
  private _currentRoute: string = Routes.Configurator;

  get configuratorRoute(): boolean {
    return this._currentRoute === Routes.Configurator;
  }

  get recapRoute(): boolean {
    return this._currentRoute === Routes.Recap;
  }

  @Mutation
  goToConfigurator() {
    this._currentRoute = Routes.Configurator;
  }

  @Mutation
  goToRecap() {
    this._currentRoute = Routes.Recap;
  }
}